import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { Routes, Route } from 'react-router-dom';
import Contact from './pages/Contact';
import Home from './pages/Home'; // ✅ Renamed properly
import MortbuzzHomeLoan from './pages/MortbuzzHomeLoan';
import BankInterestRates from './pages/BankInterestRates';
import LoanAgainstProperty from './pages/LoanAgainstProperty';
import BusinessLoan from './pages/BusinessLoan';
import PersonalLoan from './pages/PersonalLoan';
import CarLoan from './pages/CarLoan';  
import EducationLoan from './pages/EducationLoan';
import InterestRatesChart from './pages/InterestRateChart';
import Eligibility from './pages/Eligibility';
import EmiCalculator from './pages/EmiCalculator';
import HowToApply from './pages/HowToApply';
import FAQ from './pages/FAQ';
import HomeLoanTaxBenefits from './pages/HomeLoanTaxBenefits';
import MortbuzzHomeLoanOffer from './pages/MortbuzzHomeLoanOffer';
import Career from './pages/Career';
import SocietyActivities from './pages/SocietyActivities';
import AboutUs from './pages/AboutUs';
import ANF from './components/ANF';
import MortbuzzScrollHome from './MortbuzzScrollHome';

 
function App() {
  return (
    <>
      <Navbar/>
      <Routes>
        <Route path="/" element={<Home/>} /> {/* default */}
        <Route path="/contact" element={<Contact/>} />
        <Route path="/mortbuzz-home-loan" element={<MortbuzzHomeLoan />} />
        <Route path="/mortbuzz-loan-against-property" element={<LoanAgainstProperty />} />
        <Route path="/business-loan" element={<BusinessLoan />} />
        <Route path="/personal-loan" element={<PersonalLoan />} />
        <Route path="/car-loan" element={<CarLoan />} />
        <Route path="/education-loan" element={<EducationLoan />} />
        <Route path="/bank-interest-rates" element={<BankInterestRates />} />
        <Route path="/interest-rates-banks" element={<InterestRatesChart />} />
        <Route path="/eligibility-criteria" element={<Eligibility />} />
        <Route path="/emi-calculator" element={<EmiCalculator />} />
        <Route path="/how-to-apply" element={<HowToApply />} />
        <Route path="/faq-section" element={<FAQ />} />
        <Route path="/home-loan-tax-benefits" element={<HomeLoanTaxBenefits/>}/>
        <Route path="/mortbuzz-home-loan-offer" element={<MortbuzzHomeLoanOffer/>}/>
        <Route path="/Career" element = {<Career/>}/>
        <Route path="/society-activities" element ={<SocietyActivities/>}/>
        <Route path="/about-us" element = {<AboutUs/>}/>
        <Route path="/apply-now" element = {<ANF/>}/>
        <Route path="/animate" element = {<MortbuzzScrollHome/>}/>

        
      </Routes>
      <Footer/>
    </>
  );
}

export default App;
